// 项目汇报视频、PPT材料服务（移动端）
<template>
  <div class="cmain">
    <mheader></mheader>
    <div class="topimg"></div>
    <div class="center">
      <h1 class="title">项目汇报视频、PPT材料服务</h1>
      <p class="jianjie">由专业团队驻现场进行项目考察、拍摄、素材采集，针对项目优点、难点进行重点刻画表现，以及根据甲方提供图片、视频及文字材料，进行工法申报材料的制作。</p>
      <div class="img"></div>
    </div>
    <mfooter></mfooter>
  </div>
</template>

<script>
import mheader from "../../components/mobileHF/mHeader";
import mfooter from "../../components/mobileHF/mFooter";
export default {
  props: {},
  data() {
    return {};
  },
  mounted() {
    if (this.isMobile()) {
      this.$router.replace("/mItems"); //移动端跳转路由
    } else {
      this.$router.replace("/items"); //Pc端跳转路由
    }
  },
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
  components: {
    mheader,
    mfooter,
  },
};
</script>

<style scoped lang="less">
.cmain {
  .topimg {
    width: 100%;
    height: 8.9rem;
    background: url("../../assets/img/mobile/mBanner/视频ppt.png") 0 0 no-repeat;
    background-size: 100%;
  }
  .center {
    width: 100%;
    padding: 0rem 0.6rem;
    box-sizing: border-box;
    overflow: hidden;
    margin-bottom: 1rem;
    .title {
      opacity: 1;
      font-size: 1rem;
      font-family: Microsoft YaHei Bold, Microsoft YaHei Bold-Bold;
      font-weight: 700;
      text-align: center;
      color: #4279db;
      line-height: 1.4rem;
      margin: 1rem 0rem;
    }
    .jianjie {
      opacity: 1;
      font-size: 0.75rem;
      font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
      // font-weight: bolder;
      line-height: 1.3rem;
      text-align: justifyLeft;
      color: #231815;
      text-indent: 2em;
      margin-bottom: 3rem;
    }
    .img {
      height: 14rem;
      background: url("../../assets/img/mobile/项目汇报/tu@2x.png") 0 0
        no-repeat;
      background-size: 100%;
    }
  }
}
</style>
